import { SignIn } from "@clerk/clerk-react";
import { getTenant } from "@/config/tenants";

function BrandedLogin({ tenant }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white p-6" data-testid="login-page">
      <div className="w-full max-w-md flex flex-col items-center text-center">
        {tenant.logoUrl ? (
          <img src={tenant.logoUrl} alt={tenant.shortName} className="h-12 mb-5" data-testid="tenant-logo" />
        ) : (
          <div className="mb-5" data-testid="tenant-logo">
            <p className="text-brand-teal text-xs font-bold uppercase tracking-[0.25em] mb-2">{tenant.shortName}</p>
            <div className="w-12 h-1 bg-brand-teal mx-auto" />
          </div>
        )}
        <h1
          className="text-3xl lg:text-4xl font-bold text-brand-near-black mb-2 leading-tight"
          style={{ fontFamily: "Montserrat", fontWeight: 700 }}
          data-testid="tenant-portal-name"
        >
          {tenant.portalName}
        </h1>
        <p className="text-brand-slate text-sm mb-8">Sign in to continue to your portal.</p>
        <SignIn routing="hash" signUpUrl="#" fallbackRedirectUrl="/app" />
      </div>
    </div>
  );
}

function DefaultLogin() {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-white" data-testid="login-page">
      {/* Brand panel */}
      <div className="lg:w-1/2 bg-brand-cool-grey border-b lg:border-b-0 lg:border-r border-brand-border-grey flex flex-col justify-center p-10 lg:p-16">
        <div className="max-w-md">
          <img src="/logo.png" alt="Post Your Content" className="h-14 w-14 mb-5" data-testid="brand-panel-logo" />
          <p className="text-brand-teal text-xs font-bold uppercase tracking-[0.2em] mb-4">
            Post Your Content
          </p>
          <h1
            className="text-4xl lg:text-5xl font-bold text-brand-near-black mb-6 leading-tight"
            style={{ fontFamily: "Montserrat", fontWeight: 700 }}
          >
            Multi-client social content, on autopilot.
          </h1>
          <p className="text-brand-slate text-base mb-8">
            Plan calendars, approve content with the 48-hour “Silence is Approval”
            workflow, and manage every client workspace in one place.
          </p>
          <ul className="space-y-3 text-brand-slate text-sm">
            <li className="flex items-center gap-3">
              <span className="w-2 h-2 bg-brand-teal" /> Isolated workspaces per brand
            </li>
            <li className="flex items-center gap-3">
              <span className="w-2 h-2 bg-brand-teal" /> Auto-approval content calendar
            </li>
            <li className="flex items-center gap-3">
              <span className="w-2 h-2 bg-brand-teal" /> Media library & analytics
            </li>
          </ul>
        </div>
      </div>

      {/* Auth panel */}
      <div className="lg:w-1/2 flex flex-col items-center justify-center p-8 lg:p-16">
        <div className="w-full max-w-md flex flex-col items-center">
          <SignIn routing="hash" fallbackRedirectUrl="/app" appearance={{ elements: { footerAction: "hidden" } }} />
          <a href="/privacy" data-testid="privacy-policy-link" className="text-brand-slate text-xs mt-8 hover:text-brand-teal hover:underline">
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
}

export default function Login() {
  const tenant = getTenant();
  if (tenant.whiteLabel) return <BrandedLogin tenant={tenant} />;
  return <DefaultLogin />;
}
